define('common/ko/extension/formattedCardNumber',['knockout', 'underscore', 'jquery', 'jquery.payment'], function (ko, _, $) {

    ko.extenders.formattedCardNumber = function(source, value) {

        if (!value) return;

        source.formattedCardNumber = ko.pureComputed({
            read: function() {
                return $.payment.formatCardNumber(source());
            },
            write: function(cardNumber) {
                source(_.isEmpty(cardNumber) ? cardNumber : cardNumber.replace(/ /g, ''));
            }
        });
    };
});

